import React, { useContext } from 'react';
import { MyContext } from '../../context';

function WarrantyPolicyNew() {
  const { pageData } = useContext(MyContext);
  return (
    <section className="commonConditions">
      <div className="container ">
        <div className="smallContainer">
          <h1 style={{ textAlign: 'center' }}>
            {pageData?.warrantyTerms?.header}
          </h1>
          <div>
            <h2 style={{ marginTop: '1rem' }}>
              {pageData?.warrantyTerms?.subHeader1}
            </h2>
            <p>{pageData?.warrantyTerms?.point}</p>
          </div>
          <div>
            <h2 style={{ marginTop: '1rem' }}>
              {pageData?.warrantyTerms?.subHeader2}
            </h2>
            <p>
              <ul>
                {pageData?.warrantyTerms?.durationList?.map((item, index) => (
                  <li key={index} style={{ listStyleType: 'disc' }}>
                    {item}
                  </li>
                ))}
              </ul>
            </p>
          </div>
          <div>
            <h2 style={{ marginTop: '1rem' }}>
              {pageData?.warrantyTerms?.subHead3}
            </h2>
            <p>{pageData?.warrantyTerms?.subtitleExclusions}</p>
            <p>
              <ul>
                {pageData?.warrantyTerms?.exclusionsList?.map((item, index) => (
                  <li key={index} style={{ listStyleType: 'disc' }}>
                    {item}
                  </li>
                ))}
                {/* <li style={{ listStyleType: "disc" }}></li> */}
              </ul>
            </p>
          </div>
          <div>
            <h2 style={{ marginTop: '1rem' }}>
              {pageData?.warrantyTerms?.subHead4}
            </h2>
            <p>
              <ul>
                {pageData?.warrantyTerms?.warrantNotApplyList?.map(
                  (item, index) => (
                    <li key={index} style={{ listStyleType: 'disc' }}>
                      {item}
                    </li>
                  )
                )}
              </ul>
            </p>
          </div>
          <div>
            <h2 style={{ marginTop: '1rem' }}>
              {pageData?.warrantyTerms?.subtitle5}
            </h2>
            <p>
              <ul>
                {pageData?.warrantyTerms?.DamageFailureList?.map(
                  (item, index) => (
                    <li key={index} style={{ listStyleType: 'disc' }}>
                      {item}
                    </li>
                  )
                )}
              </ul>
            </p>
          </div>
          <div>
            <h2 style={{ marginTop: '1rem' }}>
              {pageData?.warrantyTerms?.subHead6}
            </h2>
            <p>
              <ul>
                {pageData?.warrantyTerms?.otherTermsList?.map((item, index) => (
                  <li key={index} style={{ listStyleType: 'disc' }}>
                    {item}
                  </li>
                ))}
              </ul>
            </p>
          </div>
          <div>
            <h2 style={{ marginTop: '1rem' }}>
              {pageData?.warrantyTerms?.subHeads7}
            </h2>
            <p>
              <ul>
                {pageData?.warrantyTerms?.customerObligationFitnessList?.map(
                  (item, index) => (
                    <li key={index} style={{ listStyleType: 'disc' }}>
                      {item}
                    </li>
                  )
                )}
              </ul>
            </p>
          </div>
          <div>
            <h2 style={{ marginTop: '1rem' }}>
              {pageData?.warrantyTerms?.subHead8}
            </h2>
            <p>
              <ul>
                {pageData?.warrantyTerms?.customerObligationRcList?.map(
                  (item, index) => (
                    <li key={index} style={{ listStyleType: 'disc' }}>
                      {item}
                    </li>
                  )
                )}
              </ul>
            </p>
          </div>
          <div>
            <h2 style={{ marginTop: '1rem' }}>
              {pageData?.warrantyTerms?.subHead9}
            </h2>
            <p>
              <ul>
                {pageData?.warrantyTerms?.responsibilitiesList?.map(
                  (item, index) => (
                    <li key={index} style={{ listStyleType: 'disc' }}>
                      {item}
                    </li>
                  )
                )}
              </ul>{' '}
              {pageData?.warrantyTerms?.subTitle1}
            </p>
          </div>
          <div>
            <h2 style={{ marginTop: '1rem' }}>
              {pageData?.warrantyTerms?.subHead10}
            </h2>
            <p>
              <ul>
                <p style={{ listStyleType: 'disc' }}>
                  {pageData?.warrantyTerms?.subTitle1}
                </p>
                <ul>
                  {pageData?.warrantyTerms?.subTitleList?.map((item, index) => (
                    <li key={index} style={{ listStyleType: 'disc' }}>
                      {item}
                    </li>
                  ))}
                </ul>
                <br />
                <p style={{ listStyleType: 'disc' }}>
                  {pageData?.warrantyTerms?.subTitle2}
                </p>
                <ul>
                  {pageData?.warrantyTerms?.subTitle2List?.map(
                    (item, index) => (
                      <li key={index} style={{ listStyleType: 'disc' }}>
                        {item}
                      </li>
                    )
                  )}
                </ul>
                <br />
                <p style={{ listStyleType: 'disc' }}>
                  {pageData?.warrantyTerms?.subTitle3}
                </p>
                <ul>
                  {pageData?.warrantyTerms?.subTitle3List?.map(
                    (item, index) => (
                      <li key={index} style={{ listStyleType: 'disc' }}>
                        {item}
                      </li>
                    )
                  )}
                </ul>
                <br />
                <p style={{ listStyleType: 'disc' }}>
                  {pageData?.warrantyTerms?.subTitle4}
                </p>
                <ul>
                  {pageData?.warrantyTerms?.subTitle4List?.map(
                    (item, index) => (
                      <li key={index} style={{ listStyleType: 'disc' }}>
                        {item}
                      </li>
                    )
                  )}
                </ul>
                <br />
                <p style={{ listStyleType: 'disc' }}>
                  {pageData?.warrantyTerms?.subTitle5}
                </p>
                <ul>
                  {pageData?.warrantyTerms?.subTitle5List?.map(
                    (item, index) => (
                      <li key={index} style={{ listStyleType: 'disc' }}>
                        {item}
                      </li>
                    )
                  )}
                </ul>
                <br />
                <p style={{ listStyleType: 'disc' }}>
                  {pageData?.warrantyTerms?.subTitle6}
                  Over-revving or redlining the engine:
                </p>
                <ul>
                  {pageData?.warrantyTerms?.subTitle6List?.map(
                    (item, index) => (
                      <li key={index} style={{ listStyleType: 'disc' }}>
                        {item}
                      </li>
                    )
                  )}
                </ul>
              </ul>
            </p>
            <br />
            <p>{pageData?.warrantyTerms?.subNote} </p>
          </div>

          <div>
            <h2 style={{ marginTop: '1rem' }}>
              {pageData?.warrantyTerms?.noteHeader}
            </h2>
            <p>
              <ul>
                {pageData?.warrantyTerms?.noteList?.map((item, index) => (
                  <li key={index} style={{ listStyleType: 'disc' }}>
                    {item}
                  </li>
                ))}
              </ul>
            </p>
          </div>
          {/* <div>
             <h2 style={{ marginTop: "1rem" }}>Note:</h2>
            <p></p>
            <br />
          </div> */}
        </div>
      </div>
    </section>
  );
}

export default WarrantyPolicyNew;
